import { Input } from './input'

type File = {
    id: Maybe<string>
    name?: string
    filename?: string
    size?: number
}

export class DocumentInput extends Input {
    constructor(language: string, input?: Partial<Input>, data?: any) {
        super(language, input)
        this.kind = input?.kind || 'attachment'
        this.name = `form_fe['revision.heading_attachmentItem']`
        this.icon = 'fa fa-paperclip'
        this.setFiles(data)
    }

    files: File[] = [{ id: null }]

    addNewFile() {
        if (this.kind === 'multiAttachment') {
            this.files.push({ id: null })
        }
    }

    setFiles(data: any) {
        this.files = [{ id: null }]

        const newFile = (file: any) => ({ ...file, name: file.filename })
        if (this.kind === 'multiAttachment') {
            if (data?.files && Array.isArray(data.files)) {
                this.files = data.files.map(newFile)
            }
        } else if (data?.file) {
            this.files = [newFile(data.file)]
        }
    }
}
